import React, {useEffect} from "react";
import {t} from "i18next";
import { useLanguageForShared } from "../../../shared/utils/languages/useLanguageForShared";


const PolicyNotice = () =>{
    const {t} = useLanguageForShared();

    return(
        <>
            <div className="policy">
                <h3 className="title">{t('policy_template_philips.privacy.title')}</h3>
                <h3 className="title">{t('policy_template_philips.privacy.subtitle')}</h3>
                <br></br>
                <p>{t('policy_template_philips.privacy.introduction')}</p>
                <br></br>
                <ul>{t('policy_template_philips.privacy.ul1')}</ul>
                    <li>{t('policy_template_philips.privacy.ul1_li1')}</li>
                    <li>{t('policy_template_philips.privacy.ul1_li2')}</li>
                    <li>{t('policy_template_philips.privacy.ul1_li3')}</li>
                    <li>{t('policy_template_philips.privacy.ul1_li4')}</li>
                    <li>{t('policy_template_philips.privacy.ul1_li5')}</li>
                    <li>{t('policy_template_philips.privacy.ul1_li6')}</li>
                    <li>{t('policy_template_philips.privacy.ul1_li7')}</li>
                <br></br>
                <p>{t('policy_template_philips.privacy.p1')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.question1')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p2')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p3')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.name')}</p>
                <p>{t('policy_template_philips.privacy.role')}</p>
                <p>{t('policy_template_philips.privacy.department')}</p>
                <p>{t('policy_template_philips.privacy.company')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.email')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.question2')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p4')}{t('policy_template_philips.privacy.ul2')}</p>
                <br></br>
                    <li>{t('policy_template_philips.privacy.ul2_li1')}</li>
                    <li>{t('policy_template_philips.privacy.ul2_li2')}</li>
                    <li>{t('policy_template_philips.privacy.ul2_li3')}</li>
                    <li>{t('policy_template_philips.privacy.ul2_li4')}</li>
                    <li>{t('policy_template_philips.privacy.ul2_li5')}</li>
                    <li>{t('policy_template_philips.privacy.ul2_li6')}</li>
                <br></br>
                <p>{t('policy_template_philips.privacy.p6')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.question3')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p7')}{t('policy_template_philips.privacy.p8')}{t('policy_template_philips.privacy.p9')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.question4')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p10')}{t('policy_template_philips.privacy.p11')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p12')}</p>
                <br></br>
                <ul>{t('policy_template_philips.privacy.ul3')}</ul>
                <br></br>
                    <li>{t('policy_template_philips.privacy.ul3_li1')}</li>
                    <li>{t('policy_template_philips.privacy.ul3_li2')}</li>
                    <li>{t('policy_template_philips.privacy.ul3_li3')}</li>
                    <li>{t('policy_template_philips.privacy.ul3_li4')}</li>
                    <li>{t('policy_template_philips.privacy.ul3_li5')}</li>
                <br></br>
                <p>{t('policy_template_philips.privacy.p13')}{t('policy_template_philips.privacy.p14')}{t('policy_template_philips.privacy.p15')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.question5')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p16')}{t('policy_template_philips.privacy.p17')}</p>
                <br></br>
                <ul>{t('policy_template_philips.privacy.ul4')}</ul>
                <br></br>
                    <li>{t('policy_template_philips.privacy.ul4_li1')}</li>
                    <li>{t('policy_template_philips.privacy.ul4_li2')}</li>
                <br></br>
                <p>{t('policy_template_philips.privacy.p18')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p19')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.question6')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p20')}{t('policy_template_philips.privacy.p21')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.question7')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p22')}{t('policy_template_philips.privacy.p23')}{t('policy_template_philips.privacy.p24')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p25')}{t('policy_template_philips.privacy.p26')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p27')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p28')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.cookies')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p30')}</p>
                <br></br>
                <ul>{t('policy_template_philips.privacy.ul5')}</ul>
                <br></br>
                    <li>{t('policy_template_philips.privacy.ul5_li1')}</li>
                    <li>{t('policy_template_philips.privacy.ul5_li2')}</li>
                <br></br>
                <p>{t('policy_template_philips.privacy.p31')}{t('policy_template_philips.privacy.p32')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p33')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.adm')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p34')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.complain')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p35')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p36')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p37')}</p>
                <p>{t('policy_template_philips.privacy.p38')}</p>
                <p>{t('policy_template_philips.privacy.p39')}</p>
                <p>{t('policy_template_philips.privacy.p40')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.privacy.changes')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p41')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p42')}</p>
                <p>{t('policy_template_philips.privacy.p43')}</p>
                <p>{t('policy_template_philips.privacy.p44')}</p>
                <br></br>
                <p className="italic">{t('policy_template_philips.privacy.p45')}</p>
                <br></br>
                <p>{t('policy_template_philips.privacy.p46')}</p>
                <p>{t('policy_template_philips.privacy.p47')}</p>

            </div>
        </>
    )
}

export default PolicyNotice